import { Component, useContext } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { TabHeader } from '../TabHeader';
import { NotificationContext, NotificationContextState } from 'context/NotificationContext';
import { TabSystemUsage } from './SystemUsage/TabSystemUsage';
import { TabDistributorsUsageView } from './DistributorUsage/TabDistributorsUsageView';
import { TabTenantsUsageView } from './TenantUsage/TabTenantsUsageView';

import log from 'loglevel';

type DistributorUsagePageState = {
    isLoading: boolean,
    showApiError: boolean    
}

type DistributorUsageInternalProps = {
    notificationContext: NotificationContextState
}

export class DistributorUsageInternal extends Component<DistributorUsageInternalProps, DistributorUsagePageState>  {
    state: DistributorUsagePageState ={
        isLoading: true,
        showApiError: false    
    }

    async componentDidMount() {
        await this.loadPageData();
    }

    loadPageData = async () => {
        try {
            this.setState({
                isLoading: false
            });
        }
        catch (error) {
            log.error(`Something went wrong: ${error}`);
        }
    }
    render() {
        const tabInfos = [
            { name: "System", tabId: "0" },
            { name: "Distributers", tabId: "1" }, 
            { name: "Tenants", tabId: "2" }
        ]

        let pageHeaderRendered = <h1>System and distributor usage</h1>

        return (
            <>
                {pageHeaderRendered}
                <TabHeader tabInfos={tabInfos}>
                    <TabContent>
                        {<>
                            <TabPane tabId="0">
                                <TabSystemUsage />
                            </TabPane>
                            <TabPane tabId="1">
                                <TabDistributorsUsageView />
                            </TabPane>  
                            <TabPane tabId="2">
                                <TabTenantsUsageView />
                            </TabPane>
                        </>}
                    </TabContent>
                </TabHeader>      
            </>
        );
    }
}

// Inject the required contexts.
export const DistributorUsage = (props: any) => {
    const notificationContext = useContext(NotificationContext);

    return (
        <DistributorUsageInternal {...props} notificationContext={notificationContext} />
    )
}